import React, { useEffect } from "react";
import { useDroppable } from "@dnd-kit/core";
import { useTranslation } from "react-i18next";

type Props = {
  id: string;
  items: any[];
  children: React.ReactNode;
}

export const DroppableContainer: React.FC<Props> = ({
  id,
  items,
  children,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const resizeObserverError = (event) => {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', resizeObserverError);
    return () => {
      window.removeEventListener('error', resizeObserverError);
    };
  }, []);

  const { isOver, setNodeRef } = useDroppable({
    id,
    data: {
      type: "container",
      children: items
    },
  });

  return (
    <div
      ref={setNodeRef}
    >
      {children}
      {items.length === 0 && (
        <div>
          {t('common:drop-items-here')}
        </div>
      )}
    </div>
  );
};